import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { X } from "lucide-react";

export default function CookieBanner() {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem("cookie-consent");
    if (!consent) {
      // Small delay before showing the banner
      const timer = setTimeout(() => setIsVisible(true), 1000);
      return () => clearTimeout(timer);
    }
  }, []);

  const acceptAll = () => {
    localStorage.setItem("cookie-consent", JSON.stringify({
      necessary: true,
      analytics: true,
      marketing: true,
      timestamp: new Date().toISOString()
    }));
    setIsVisible(false);
  };

  const acceptNecessary = () => {
    localStorage.setItem("cookie-consent", JSON.stringify({
      necessary: true,
      analytics: false,
      marketing: false,
      timestamp: new Date().toISOString()
    }));
    setIsVisible(false);
  };

  if (!isVisible) return null;

  return (
    <div 
      data-testid="cookie-banner"
      className="fixed bottom-0 left-0 right-0 bg-white border-t border-slate-200 shadow-lg z-50"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4 md:py-6">
        <div className="flex flex-col lg:flex-row items-start lg:items-center justify-between gap-4">
          <div className="flex-1">
            <h4 className="font-semibold text-slate-900 mb-1">
              Cookie-Einstellungen
            </h4>
            <p className="text-sm text-slate-600">
              Wir verwenden Cookies, um Ihnen die bestmögliche Erfahrung auf unserer Website zu bieten. 
              Weitere Informationen finden Sie in unserer{" "}
              <Link to="/datenschutz" className="text-[#003B70] hover:underline">
                Datenschutzerklärung
              </Link>.
            </p>
          </div>
          <div className="flex flex-col sm:flex-row items-stretch sm:items-center gap-3 w-full lg:w-auto">
            <Button
              data-testid="cookie-accept-necessary"
              variant="outline"
              onClick={acceptNecessary}
              className="border-slate-300 text-slate-700 hover:bg-slate-50"
            >
              Nur notwendige
            </Button>
            <Button
              data-testid="cookie-accept-all"
              onClick={acceptAll}
              className="bg-[#003B70] hover:bg-[#002855] text-white"
            >
              Alle akzeptieren
            </Button>
          </div>
          <button
            data-testid="cookie-close"
            onClick={acceptNecessary}
            className="absolute top-4 right-4 lg:hidden text-slate-400 hover:text-slate-600"
            aria-label="Schließen"
          >
            <X className="h-5 w-5" />
          </button>
        </div>
      </div>
    </div>
  );
}
